import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { Neutrals, SemanticError } from '../../color-palette/colors';

import type { CodeInputAlign } from './CodeInput';

export const MESSAGE_LINE_HEIGHT = 1.5;

export const messageSx = (align: CodeInputAlign): SystemStyleObject<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  alignItems: align === 'center' ? 'center' : 'flex-start',
  textAlign: align === 'center' ? 'center' : 'start',
});

export const lineSx: SystemStyleObject<Theme> = { display: 'flex', alignItems: 'center', gap: 1 };
export const errorTextSx: SystemStyleObject<Theme> = { color: SemanticError[600], lineHeight: MESSAGE_LINE_HEIGHT };
export const quietTextSx: SystemStyleObject<Theme> = { color: Neutrals[700], lineHeight: MESSAGE_LINE_HEIGHT };
export const errorIconSx: SystemStyleObject<Theme> = { color: SemanticError[600], flexShrink: 0 };
